/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';


export default class extends Logic
{
  constructor ({ data, overlay })
  {
    super(data);

    this.overlay = overlay;
  }


  equals (other)
  {
    return super.equals(other) && this.overlay.equals(other.overlay);
  }


  getCenterDisplayHex ()
  {
    return this.object.getCenterDisplayHex();
  }


  getZone (displayHex)
  {
    return this.object.getZone(displayHex) ?? this.overlay.getZone(displayHex);
  }


  getZones ()
  {
    return [ ...this.object.getZones(), ...this.overlay.getZones() ];
  }


  getSelectableZone (displayHex)
  {
    return this.object.getSelectableZone(displayHex);
  }


  toEntityHex (displayHex)
  {
    return this.object.toEntityHex(displayHex);
  }


  toDisplayHex (entityHex)
  {
    return this.object.toDisplayHex(entityHex);
  }


};
